import TenantNotification from '../../components/settings/tenant/TenantNotification'

const Notifications = () => {
  return (
    <div className="mb-2 flex w-full flex-col">
      <TenantNotification />
    </div>
  )
}

export default Notifications
